<mat-card class="group-card">
  <mat-card-header class="header layout-column">
    <mat-card-title-group class="header-title-group">
      <div class="profile-image-container">
        <div>
          <img mat-card-md-image class="profile-image" src="assets/images/group_placeholder.png" />
        </div>
      </div>

      <div class="mat-typography group-card-title">
        <mat-card-title class="make-flex">
          <h3 class="flex-95">
            <i
              class="fa fa-stop"
              [ngClass]="groupViewData.status.code | statusLookup"
              [matTooltip]="groupViewData.status.value"
            ></i>
            {{ 'labels.heading.Group Name' | translate }} : {{ groupViewData.name }}
          </h3>

          <div class="flex-5 flex-xs-15 flex-sm-10 flex-md-5">
            <button mat-icon-button [matMenuTriggerFor]="groupMenu" aria-label="Group actions" yPosition="below">
              <mat-icon matListIcon class="actions-menu">
                <fa-icon icon="bars" size="sm"></fa-icon>
              </mat-icon>
            </button>
          </div>
        </mat-card-title>

        <mat-card-subtitle class="make-flex">
          <div class="flex-45">
            <b>{{ 'labels.inputs.Group' | translate }} :</b> {{ groupViewData.name }} |
            <b>{{ 'labels.inputs.Center Name' | translate }}:</b> {{ groupViewData.centerName }} |
            <b>{{ 'labels.inputs.Staff' | translate }}:</b> {{ groupViewData.staffName || 'Unassigned' }}<br />
            <b>{{ 'labels.inputs.Office Name' | translate }} :</b> {{ groupViewData.officeName }}<br />
            <b>{{ 'labels.inputs.Activation Date' | translate }} :</b>
            {{ groupViewData.activationDate ? (groupViewData.activationDate | dateFormat) : 'Not Activated' }}<br />
            @if (!groupViewData.active) {
              <span>
                <b>{{ 'labels.inputs.Closure Date' | translate }} :</b>
                {{ groupViewData.timeline.closedOnDate | dateFormat }}
              </span>
            }
          </div>
          <div class="group-meeting flex-45 align-start-start">
            @if (groupViewData.collectionMeetingCalendar) {
              <div>
                <p>
                  {{ 'labels.inputs.Next Meeting on' | translate }}:
                  {{ groupViewData.collectionMeetingCalendar?.nextTenRecurringDates[0] | dateFormat }}
                  @if (editMeeting) {
                    <i class="fa fa-edit" (click)="doAction('Edit Meeting')"></i>
                  }
                  <br />
                  {{ 'labels.inputs.Meeting Frequency' | translate }}:
                  {{ groupViewData.collectionMeetingCalendar?.frequency.value | lowercase }}
                </p>
              </div>
            } @else {
              <div>
                <p>
                  {{ 'labels.inputs.Next Meeting on' | translate }}: {{ 'labels.inputs.Unassigned' | translate }}
                  <i class="fa fa-calendar"></i><br />
                  {{ 'labels.inputs.Meeting Frequency' | translate }}: {{ 'labels.inputs.N/A' | translate }}
                </p>
              </div>
            }
          </div>
        </mat-card-subtitle>
      </div>

      <mat-menu #groupMenu="matMenu">
        @if (!(groupViewData.status.value === 'Active')) {
          <span>
            <button mat-menu-item *LOSxHasPermission="'UPDATE_GROUP'" (click)="doAction('Activate')">
              <mat-icon matListIcon>
                <fa-icon icon="checkSign" size="sm"></fa-icon>
              </mat-icon>
              <span>{{ 'labels.buttons.Activate' | translate }}</span>
            </button>
          </span>
        }
        <button mat-menu-item *LOSxHasPermission="'UPDATE_GROUP'" (click)="doAction('Edit')">
          <mat-icon matListIcon>
            <fa-icon icon="edit" size="sm"></fa-icon>
          </mat-icon>
          <span>{{ 'labels.buttons.Edit' | translate }}</span>
        </button>
        <button mat-menu-item *LOSxHasPermission="'ASSOCIATECLIENTS_GROUP'" (click)="doAction('Transfer Clients')">
          <mat-icon matListIcon>
            <fa-icon icon="users" size="sm"></fa-icon>
          </mat-icon>
          <span>{{ 'labels.buttons.Transfer Clients' | translate }}</span>
        </button>
        <button mat-menu-item *LOSxHasPermission="'TRANSFERCLIENTS_GROUP'" (click)="doAction('Manage Members')">
          <mat-icon matListIcon>
            <fa-icon icon="user" size="sm"></fa-icon>
          </mat-icon>
          <span>{{ 'labels.buttons.Manage Members' | translate }}</span>
        </button>

        @if (groupViewData.active) {
          <button mat-menu-item [matMenuTriggerFor]="AccountApplications">
            <mat-icon matListIcon>
              <fa-icon icon="money-bill-alt" size="sm"></fa-icon>
            </mat-icon>
            <span>{{ 'labels.buttons.Applications' | translate }}</span>
          </button>
        }

        <mat-menu #AccountApplications="matMenu">
          @if (groupViewData.clientMembers) {
            <span>
              <button mat-menu-item *LOSxHasPermission="'CREATE_LOAN'">
                {{ 'labels.buttons.Bulk JLG Loan Application' | translate }}
              </button></span
            >
          }
          <button
            mat-menu-item
            *LOSxHasPermission="'CREATE_SAVINGSACCOUNT'"
            [routerLink]="['savings-accounts', 'create']"
          >
            {{ 'labels.buttons.Group Saving Application' | translate }}
          </button>
          <button mat-menu-item *LOSxHasPermission="'CREATE_LOAN'" [routerLink]="['loans-accounts', 'create']">
            {{ 'labels.buttons.Group Loan Application' | translate }}
          </button>
          @if (groupViewData.clientMembers) {
            <span>
              <button
                mat-menu-item
                *LOSxHasPermission="'CREATE_LOAN'"
                [routerLink]="['loans-accounts', 'glim-account', 'create']"
              >
                {{ 'labels.buttons.GLIM Application' | translate }}
              </button>
            </span>
          }
          @if (groupViewData.clientMembers) {
            <span>
              <button
                mat-menu-item
                *LOSxHasPermission="'CREATE_GSIMACCOUNT'"
                [routerLink]="['savings-accounts', 'gsim-account', 'create']"
              >
                {{ 'labels.buttons.GSIM Application' | translate }}
              </button>
            </span>
          }
        </mat-menu>

        <button mat-menu-item [matMenuTriggerFor]="More">{{ 'labels.buttons.More' | translate }}</button>
        <mat-menu #More="matMenu">
          @if (groupViewData.collectionMeetingCalendar) {
            <span>
              <button
                mat-menu-item
                *LOSxHasPermission="'SAVEORUPDATEATTENDANCE_MEETING'"
                (click)="doAction('Attendance')"
              >
                {{ 'labels.buttons.Attendance' | translate }}
              </button></span
            >
          }
          @if (!groupViewData.staffId) {
            <span>
              <button mat-menu-item *LOSxHasPermission="'ASSIGNSTAFF_GROUP'" (click)="doAction('Assign Staff')">
                {{ 'labels.buttons.Assign Staff' | translate }}
              </button></span
            >
          }
          @if (groupViewData.staffId) {
            <span>
              <button mat-menu-item *LOSxHasPermission="'UNASSIGNSTAFF_GROUP'" (click)="doAction('Unassign Staff')">
                {{ 'labels.buttons.Unassign Staff' | translate }}
              </button></span
            >
          }
          @if (
            !(groupViewData.centerId || groupViewData.collectionMeetingCalendar) &&
            groupViewData.status.value === 'Active'
          ) {
            <span>
              <button mat-menu-item *LOSxHasPermission="'CREATE_MEETING'" (click)="doAction('Attach Meeting')">
                {{ 'labels.buttons.Attach Meeting' | translate }}
              </button></span
            >
          }
          <button mat-menu-item *LOSxHasPermission="'CLOSE_GROUP'" (click)="doAction('Close')">
            {{ 'labels.buttons.Close' | translate }}
          </button>
          <button mat-menu-item *LOSxHasPermission="'DELETE_GROUP'" (click)="doAction('Delete')">
            {{ 'labels.buttons.Delete' | translate }}
          </button>
        </mat-menu>
      </mat-menu>
    </mat-card-title-group>
  </mat-card-header>

  <mat-card-content>
    <nav mat-tab-nav-bar class="navigation-tabs" [tabPanel]="tabPanel">
      <a
        mat-tab-link
        [routerLink]="['./general']"
        routerLinkActive
        #general="routerLinkActive"
        [active]="general.isActive"
      >
        {{ 'labels.inputs.General' | translate }}
      </a>
      <a
        mat-tab-link
        [routerLink]="['./notes']"
        *LOSxHasPermission="'READ_GROUPNOTE'"
        routerLinkActive
        #notes="routerLinkActive"
        [active]="notes.isActive"
      >
        {{ 'labels.inputs.Notes' | translate }}
      </a>
      <a
        mat-tab-link
        [routerLink]="['./committee']"
        routerLinkActive
        #committee="routerLinkActive"
        [active]="committee.isActive"
      >
        {{ 'labels.inputs.Committee' | translate }}
      </a>
      @for (groupDatatable of groupDatatables; track groupDatatable) {
        <span>
          <a
            mat-tab-link
            *LOSxHasPermission="'READ_' + groupDatatable.registeredTableName"
            [routerLink]="['./datatables', groupDatatable.registeredTableName]"
            routerLinkActive
            #datatable="routerLinkActive"
            [active]="datatable.isActive"
          >
            {{ groupDatatable.registeredTableName }}
          </a>
        </span>
      }
    </nav>

    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </mat-card-content>
</mat-card>
